import React from "react";
import { SignupStageHandlerComponent } from "./SignupStageHandlerComponent.type";
import usePromise from "../../utils/hooks/usePromise";
import _ from "lodash";
import { FORM_STAGE } from "../../contexts/form";
import BaseLayout from "../../layouts/base";
import { apiBaseUri } from "../../config";
import FormSuccess from "./ProcessForm/FormSuccess";
import { useAuth } from "../../utils/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { PAGE_PATHS } from "../page-paths";

export const ProcessForm: SignupStageHandlerComponent = ({
  formState,
  formStage,
  setFieldValue,
  clearForm,
}) => {
  const {
    authState: { vle },
    validatingToken,
  } = useAuth();

  console.log(vle);
  const navigate = useNavigate();

  usePromise(
    {
      fn: async () => {
        if (formState.signupType === "assisted" && !validatingToken && !vle)
          navigate(PAGE_PATHS.DEFAULT_NAVIGABLE);
        else {
          const endpoint =
            formState.signupType === "assisted"
              ? "create-learner-onboarding-payment-request"
              : "create-learner-onboarding-payment-request-open";

          if (formStage === FORM_STAGE.READY_FOR_SUBMISSION) {
            const payload = _.pick(formState, [
              "name",
              "salutation",
              "email",
              "mobileNumber",
              "gender",
              "dateOfBirth",
              "category",
              "fatherName",
              "isPhysicallyChallenged",
              "highestQualification",
              "addressLine1",
              "pincode",
              "identityProofType",
              "identityProofNumber",
              "identityProofFileId",
              "highestQualificationCertificateFileId",
              "candidatePhotoFileId",
              "candidateSignatureFileId",
              "batchId",
              "courseId",
              "partnerId",
              "examCenterState",
              "examCenterCity",
              "examLanguage",
            ]);

            if (!payload.mobileNumber) delete payload.mobileNumber;
            if (!payload.email) delete payload.email;

            setFieldValue("isFormSubmitted", true);
            submitForm(payload, endpoint);
          }
        }
      },
      runOnMount: { args: [] },
      runOnRerender: { args: [], enabled: true },
    },
    [formStage, vle, validatingToken, formState.signupType]
  );

  // const retryFormSubmission = useCallback(
  //   () => setFieldValue("isFormSubmitted", false),
  //   [setFieldValue]
  // );

  // const goBack = useCallback(
  //   () => setFieldValue("isPersonalDetailsFinalised", false),
  //   [setFieldValue]
  // );

  return (
    <BaseLayout noIcon>
      {formStage === FORM_STAGE.READY_FOR_SUBMISSION ? (
        <span className="text-2xl">Processing...</span>
      ) : formStage === FORM_STAGE.SUCCESSFUL ? (
        <FormSuccess formState={formState} clearForm={clearForm} />
      ) : (
        <div className="w-full text-center text-2xl">Processing...</div>
      )}
    </BaseLayout>
  );
};

const submitForm = (payload: { [key: string]: any }, endpoint: string) => {
  const form = document.createElement("form");
  form.setAttribute("action", apiBaseUri + "/" + endpoint);
  form.setAttribute("method", "post");

  for (const formField of Object.keys(payload)) {
    const inputField = document.createElement("input");
    inputField.setAttribute("name", formField);
    inputField.setAttribute("type", "hidden");
    inputField.value = payload[formField];
    form.appendChild(inputField);
  }

  document.body.appendChild(form);
  form.submit();
};
